// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackForm-cls1_WNv","cls2":"FeedbackForm-cls2_TyM FeedbackForm-cls1_WNv"};